import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MessageTextBody } from '../../../../../models/message-text-body';
import { MessageVideoCallInfo } from '../../../../../models/message-video-call'
import { Message } from './../../../../../models/message';
import { LinkifyService, TextMessagePart } from '../../../../../utilities/linkify/linkify.service';
import { TeamnoteConfigService } from '../../../../../configs/teamnote-config.service';
import { UserContact } from '../../../../../models/user-contact';
import { UserContactService } from '../../../../services/data/user-contact/user-contact.service';
import { VideoCallService } from '../../video-call/video-call.service';
import { VideoCallMessageService } from './video-call-message.service'
import * as _ from 'lodash';

@Component({
  selector: 'tn-video-call-message',
  templateUrl: './video-call-message.component.html',
  styleUrls: ['./video-call-message.component.scss']
})
export class VideoCallMessageComponent implements OnInit {
  @Input() message: Message;
  @Input() parsedMessages: Message[];
  @Input() body: MessageVideoCallInfo;
  @Input() isVideoCall: boolean;
  @Output() onUserClick: EventEmitter<UserContact> = new EventEmitter<UserContact>(null);
  @Output() onHashtagClick: EventEmitter<string> = new EventEmitter<string>(null);


  constructor(
    private _teamnoteConfigService: TeamnoteConfigService,
    private _videoCallService: VideoCallService,
    private _videoCallMessageService: VideoCallMessageService,
  ) { }

  ngOnInit() {
    // console.log('video call message init', this.body)
    if (!this.body) {
      return;
    }

    if (this.body.status === 0 && this.body.end_time !== null) {
      return
    }

    // console.log(this.body)
    this._videoCallMessageService.storeTargetVideoCallInfo(this.body)

    // if (_.last(this.parsedMessages).parsedBody.status !== 1) {
    //   return
    // }

    if (this.message.parsedBody.status !== 1) {
      return
    }

    // this._videoCallMessageService.storeCaller(_.last(this.parsedMessages).sent_by)
    this._videoCallMessageService.storeCaller(this.message.sent_by)
  }

  ngOnChanges() {
    
  }

}
